import { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import PageLoading from 'components/PageLoading';

const BMCDebugLog = lazy(() => import('./BmcDebugLog'));
const RemoteMonitoring = lazy(() => import('./RemoteMonitoring'));

const Root = () => {
  return (
    <Routes>
      <Route
        path="/bmc-debug-log"
        element={
          <Suspense fallback={<PageLoading />}>
            <BMCDebugLog />
          </Suspense>
        }
      />
      <Route
        path="/remote-monitoring"
        element={
          <Suspense fallback={<PageLoading />}>
            <RemoteMonitoring />
          </Suspense>
        }
      />
    </Routes>
  );
};

export default Root;
